import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { IBuiltInInstrumentSummary } from '@brushfire/types'
import { BuiltInInstrumentCard } from './BuiltInInstrumentCard'

type Props = Readonly<{
  entries: IBuiltInInstrumentSummary[]
  canRemove: boolean
  onOpenEntry: (entry: IBuiltInInstrumentSummary) => void
  onRequestRemove: (entry: IBuiltInInstrumentSummary) => void
}>

export function BuiltInInstrumentsSection({
  entries,
  canRemove,
  onOpenEntry,
  onRequestRemove,
}: Props) {
  if (entries.length === 0) return null

  return (
    <Box
      component="section"
      data-testid="built-in-instruments-section"
      sx={{ mt: 4 }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '24px',
          lineHeight: '31.2px',
          color: '#061940',
          mb: 3,
        }}
      >
        Built-in Instruments
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
          gap: 3,
        }}
      >
        {entries.map((entry) => (
          <BuiltInInstrumentCard
            key={entry.id}
            entry={entry}
            canRemove={canRemove}
            onOpen={() => onOpenEntry(entry)}
            onRequestRemove={() => onRequestRemove(entry)}
          />
        ))}
      </Box>
    </Box>
  )
}
